<template>
  <v-app id="inspire">
    <v-navigation-drawer
      fixed
      clipped
      app
     :mobile-break-point="mobilePoint"
     :mini-variant="miniNav"
     v-model="navVisible"
    >
      <div class="aside-brand-wrap">
        <div class="aside-brand">
          <span href="" class="aside-avatar elevation-2">
            <img v-if="authUser.avatar_thumbnail" :src="authUser.avatar_thumbnail" />
            <img v-if="!authUser.avatar_thumbnail" src="@/assets/img/avatar.png" />
          </span>
      <span class="subheading">{{authUser.full_name}}</span>

        </div>
      </div>
      <admin-nav list :mini="miniNav" v-if="isAdmin"></admin-nav>
      <trainer-nav list v-if="isTrainer"></trainer-nav>
      <runner-nav list v-if="isRunner"></runner-nav>
    </v-navigation-drawer>
    <v-toolbar color="white" fixed clipped-left app>
      <v-toolbar-side-icon @click.stop="toggleNav"></v-toolbar-side-icon>
      <v-toolbar-title>
        <v-img class="hidden-sm-and-down" width="150" :src="require('@/assets/img/logo.jpg')"/>
        <v-img class="hidden-md-and-up" width="30" :src="require('@/assets/img/logo-symbol.jpg')"/>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<admin-nav v-if="isAdmin"></admin-nav>-->
      <!--<trainer-nav v-if="isTrainer"></trainer-nav>-->
      <!--<runner-nav v-if="isRunner"></runner-nav>-->
      <v-menu
            v-if="isAuthenticated && userLoaded"
            transition="slide-y-transition"
            bottom
          >
            <v-btn
              slot="activator"
              flat
            >
              <em>{{authUser.email}}</em>
            </v-btn>
            <v-list>
              <v-list-tile v-if="isAdmin" :to="{name: 'my-profile'}">
                <v-list-tile-title>Zmień hasło</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="!isAdmin" :to="{name: 'my-profile'}">
                <v-list-tile-title>Profil</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="logout">
                <v-list-tile-title>Wyloguj</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer
      absolute inset app
      height="auto"
    >
      <v-card
        class="flex"
        flat
        tile
      >
      <v-card-actions class="justify-center flex-wrap-reverse">
        <span>&copy; {{new Date().getFullYear()}} -  Inżynieria Biegania</span>
        <span>
          <a class="mx-3" target="blank" href="http://inzynieriabiegania.pl/regulamin/">Regulamin</a>
          <v-btn
            class="mx-3"
            icon
            href="https://www.facebook.com/inzynieriabiegania/"
            target="blank"
          >
            <v-icon size="24px" color="primary">mdi-facebook-box</v-icon>
          </v-btn>
          <v-btn
            class="mx-3"
            icon
            href="https://www.instagram.com/inzynieria.biegania/"
            target="blank"
          >
            <v-icon size="24px" color="primary">mdi-instagram</v-icon>
          </v-btn>
          <v-btn
            class="mx-3"
            icon
            href="https://www.youtube.com/channel/UCveuB_K3xHQQAFkJXyj4mFw?view_as=subscriber"
            target="blank"
          >
            <v-icon size="24px" color="primary">mdi-youtube</v-icon>
          </v-btn>
        </span>
      </v-card-actions>
    </v-card>
  </v-footer>
  </v-app>
</template>

<script>
import {mapGetters} from 'vuex'
import AdminNav from './AdminNav'
import TrainerNav from './TrainerNav'
import RunnerNav from './RunnerNav'

import * as types from '@/store/mutation-types'
export default {
  name: 'app',
  components: {AdminNav, TrainerNav, RunnerNav},
  data () {
    return {
      navVisible: false,
      miniNav: false,
      mobilePoint: 1264
    }
  },
  mounted () {
    if (window.innerWidth > this.mobilePoint) {
      this.navVisible = true
    }
  },
  methods: {
    toggleNav () {
      if (window.innerWidth > this.mobilePoint) {
        this.navVisible = true
        this.miniNav = !this.miniNav
      } else {
        this.navVisible = !this.navVisible
        this.miniNav = false
      }
    },
    logout: function () {
      this.$store.dispatch(types.AUTH_LOGOUT)
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'authUser', 'userLoaded', 'isTrainer', 'isRunner', 'isAdmin']),
    year: function () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style>
.aside-brand-wrap {
    background-image: url('../assets/img/trianglify.jpg');
    background-size: 100%;
}
.aside-brand {
    padding: 25px 50px 24px;
    width: 300px;
    height: 200px;
    transition: .2s ease-in-out;
    text-align: center;
}
.aside-avatar {
    margin: 20px auto 10px;
    display: block;
    width: 100px;
    height: 100px;
    border: 2px solid #fff;
    border-radius: 50%;
    overflow: hidden;
    transition: .2s ease-in-out;
}
.v-navigation-drawer--mini-variant .aside-avatar {
    margin: 0px auto 0px;
    width: 40px;
    height: 40px;
}
.v-navigation-drawer--mini-variant .aside-brand {
  padding: 6px 0px 10px 0px;
  width: auto;
  height: auto;
}

.aside-avatar img {
    width: 100%;
    height: 100%;
}

.aside-brand .subheading {
  font-size: 18px !important;
  color: #fff;
}
.v-navigation-drawer--mini-variant .aside-brand .subheading {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/layouts/AppLayout.vue